<template>
  <section
    id="isso-thread"
  >
    <div class="columns">
      <div class="column">
        <textarea
          v-model="content"
          class="textarea"
          placeholder="Escribe un mensaje"
        />
      </div>
      <div class="column is-one-quarter button-isso">
        <button
          type="submit"
          class="button is-illuminating-emerald"
          @click="submit_comment(content,name,email,website,notification)"
        >
          Enviar
        </button>
      </div>
    </div>

    <div
      v-if="
        $route.name !== 'StatusAccountDetail'
        && this.$store.state.auth.packages
        && this.$store.state.auth.packages.includes('envioSMS')
      "
    >
      <input
        id="sms"
        v-model="sms"
        name="sms"
        class="is-checkradio"
        :class="{ 'is-success': sms }"
        type="checkbox"
      >
      <label
        for="sms"
      >
        Enviar SMS
      </label>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    parent: { type: Number, default: null },
    error: { type: String, default: null },
    oldcontent: { type: String, default: '' },
  },
  data() {
    let oldcon = this.oldContent;
    if (oldcon) {
      oldcon = this.oldcontent;
    }
    return {
      name: (this.$route.name === 'StatusAccountDetail') ? this.$store.state.customers.temporal.name : this.$store.state.company.name,
      content: oldcon || '',
      email: (this.$route.name === 'StatusAccountDetail') ? this.$store.state.customers.temporal.email : this.$store.state.auth.email,
      website: null,
      notification: 0,
      sms: false,
    };
  },
  mounted() {
    this.$nextTick(this.addCtrlEnterListeners);
  },
  methods: {
    async submit_comment(content, name, email) {
      const submit = await this.$emit('submit', content, name, email, this.sms);
      if (!submit.error) {
        this.content = null;
      }
    },
  },
};

</script>
<style scoped>
  button {
    width: 60%;
    height: 50%;
  }

  .button-isso {
    display: flex;
    align-items: center;
    vertical-align: middle;
  }

  .is-checkradio[type="checkbox"] {
    position: relative;
  }

  #isso-thread textarea {
    min-height: 80px;
  }
</style>
